import { Helmet, HelmetProvider } from 'react-helmet-async';

export default () => {

  return (
    <HelmetProvider>
      <Helmet>
        <link
          rel="stylesheet"
          type="text/css"
          href={`https://ws1.postescanada-canadapost.ca/css/addresscomplete-2.50.min.css`}
        />
        <script
          type="text/javascript"
          id="canadaPostAddressComplete"
          src={`https://ws1.postescanada-canadapost.ca/js/addresscomplete-2.50.min.js`}>
        </script>
      </Helmet>
    </HelmetProvider>
  );
};